import {
  BarChart3,
  BookOpen,
  CreditCard,
  GraduationCap,
  History,
  LayoutDashboard,
  Tags,
  User,
  Users,
} from 'lucide-react'
import { Outlet } from 'react-router-dom'
import { DashboardShell } from './dashboard-shell'

const NAV_ITEMS = [
  { label: 'Dashboard', to: '/admin/dashboard', icon: LayoutDashboard },
  { label: 'Users', to: '/admin/users', icon: Users },
  { label: 'Courses', to: '/admin/courses', icon: BookOpen },
  { label: 'Categories', to: '/admin/categories', icon: Tags },
  { label: 'Enrollments', to: '/admin/enrollments', icon: GraduationCap },
  { label: 'Payments', to: '/admin/payments', icon: CreditCard },
  { label: 'Analytics', to: '/admin/analytics', icon: BarChart3 },
  { label: 'Audit log', to: '/admin/audit-log', icon: History },
  { label: 'Profile', to: '/profile', icon: User },
]

export function AdminLayout() {
  return (
    <DashboardShell navItems={NAV_ITEMS}>
      <Outlet />
    </DashboardShell>
  )
}
